import type { MouseEvent } from 'react'
import type { TaskStatus } from '@/lib/types'

const config: Record<TaskStatus, { label: string; dot: string; badge: string }> = {
  'not-started': {
    label: 'Not Started',
    dot: 'bg-[#94A3B8]',
    badge: 'bg-[#F1F5F9] text-[#64748B] border border-[#E2E8F0]',
  },
  'in-progress': {
    label: 'In Progress',
    dot: 'bg-[#F59E0B]',
    badge: 'bg-[#FEF3C7] text-[#B45309] border border-[#FDE68A]',
  },
  done: {
    label: 'Done',
    dot: 'bg-[#16A34A]',
    badge: 'bg-[#DCFCE7] text-[#15803D] border border-[#BBF7D0]',
  },
}

export function StatusBadge({
  status,
  onClick,
  title,
}: {
  status: TaskStatus
  /** Jika diisi, badge jadi tombol yang bisa diklik (mis. untuk cycle status). */
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
  title?: string
}) {
  const c = config[status]
  const base = `inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-[11px] font-medium font-body select-none ${c.badge}`
  const inner = (
    <>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${c.dot}`} />
      {c.label}
    </>
  )

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        title={title}
        aria-label={title ?? `Status: ${c.label}. Klik untuk ubah.`}
        className={`${base} cursor-pointer hover:brightness-95 hover:shadow-sm active:scale-95 focus:outline-none focus:ring-2 focus:ring-[#6366F1]/40 transition-all`}
      >
        {inner}
      </button>
    )
  }

  return <span className={base}>{inner}</span>
}
